module.exports = __webpack_public_path__ + "img/tdLogo.f55db4d9.png";